import { Mic, MicOff, Loader2 } from "lucide-react";

interface VoOrbProps {
  isListening: boolean;
  isStreaming: boolean;
  onClick: () => void;
}

export function VoOrb({ isListening, isStreaming, onClick }: VoOrbProps) {
  const isDisabled = isStreaming;

  return (
    <div className="flex flex-col items-center gap-2 select-none">
      <p className="text-xs font-medium text-muted-foreground tracking-wide uppercase">
        Chat with Vo
      </p>

      <button
        onClick={onClick}
        disabled={isDisabled}
        className="relative w-16 h-16 rounded-full focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 disabled:opacity-40 disabled:cursor-not-allowed group"
        title={isListening ? "Stop listening" : "Talk to Vo"}
      >
        {/* Animated gradient ring — pulses when listening */}
        <span
          className={`absolute inset-0 rounded-full bg-gradient-to-br from-[#9a26d1] via-[#f37037] to-[#ef4269] transition-all duration-300 ${
            isListening
              ? "opacity-80 scale-110 animate-pulse"
              : "opacity-50 group-hover:opacity-70 group-hover:scale-105"
          }`}
        />
        {/* Inner white ball */}
        <span
          className={`absolute inset-1 rounded-full shadow-inner flex items-center justify-center transition-transform duration-150 ${
            isListening ? "scale-95" : "scale-100"
          }`}
          style={{
            background: "radial-gradient(circle at 35% 35%, #ffffff 0%, #e8e8e8 100%)",
            boxShadow: "inset 2px 2px 6px rgba(255,255,255,0.8), inset -2px -2px 6px rgba(0,0,0,0.08)",
          }}
        >
          {isStreaming ? (
            <Loader2 className="h-4 w-4 text-[#9a26d1] animate-spin" />
          ) : isListening ? (
            <MicOff className="h-4 w-4 text-[#f37037]" />
          ) : (
            <Mic className="h-4 w-4 text-[#a27676]" />
          )}
        </span>
      </button>

      <p className="text-[11px] font-medium text-[#a27676] h-4">
        {isStreaming ? "Thinking…" : isListening ? "Stop" : "Talk"}
      </p>
    </div>
  );
}
